@use '../@shared/mixins' as *;
@use '../@shared/global' as *;

@layer kol-component {
	.kol-progress {
		&__bar {
			display: grid;
			align-items: center;
			grid-template-areas:
				'LABEL LABEL LABEL'
				'BAR VALUE UNIT';
			grid-template-columns: 1fr auto;

			&-label {
				grid-column-end: 2;
				grid-area: LABEL;
			}

			svg {
				grid-area: BAR;
			}

			&-value {
				grid-area: VALUE;
				text-align: right;
			}

			&-unit {
				grid-area: UNIT;
			}

			&-border {
				fill: transparent;
				stroke: black;
			}

			&-background {
				fill: lightgray;
				stroke: white;
			}

			&-progress {
				fill: #0075ff;
				stroke: transparent;

				@media (prefers-reduced-motion: no-preference) {
					transition: 250ms ease-in-out 50ms;
				}
			}
		}

		&__cycle {
			display: grid;
			align-content: center;
			justify-items: center;
			grid-template-areas: 'ALL';
			grid-template-columns: auto;

			> * {
				grid-area: ALL;
			}

			&-text {
				display: flex;
				flex-direction: column;
				justify-content: center;

				font-size: x-small;
				text-align: center;

				* {
					background-color: white;
				}
			}

			&-background {
				fill: transparent;
				stroke: lightgray;
			}

			&-border {
				fill: transparent;
				stroke: black;
			}

			&-whitespace {
				fill: transparent;
				stroke: white;
			}

			&-progress {
				transform: rotate(-90deg);
				transform-origin: 50% 50%;
				fill: transparent;
				stroke: #0075ff;

				@media (prefers-reduced-motion: no-preference) {
					transition: 250ms ease-in-out 50ms;
				}
			}
		}
	}
}
